{
  "validation": {
    "required": "Este campo es obligatorio.",
    "invalid_type": "Tipo inválido, se esperaba '{{{expected}}}'.",
    "too_small": "El valor es demasiado pequeño. El mínimo permitido es '{{min}}'.",
    "too_big": "El valor es demasiado grande. El máximo permitido es '{{max}}'.",
    "invalid_email": "Formato de correo electrónico inválido.",
    "invalid_url": "Formato de URL inválido.",
    "invalid_date": "Formato de fecha inválido.",
    "invalid_enum_value": "Selección inválida. Los valores permitidos son '{{values}}'.",
    "invalid_string": "Entrada inválida, se esperaba una cadena de texto.",
    "invalid_number": "Entrada inválida, se esperaba un número.",
    "passwordMustBeLongerThan": "La contraseña debe tener más de {{value}} caracteres",
    "passwordMustBeShorterThan": "La contraseña debe tener menos de {{value}} caracteres",
    "passwordMustContainUppercase": "La contraseña debe contener al menos una letra mayúscula",
    "passwordMustContainLowercase": "La contraseña debe contener al menos una letra minúscula",
    "passwordMustContainNumber": "La contraseña debe contener al menos un número",
    "passwordMustContainSpecialCharacter": "La contraseña debe contener al menos un carácter especial",
    "errors": {
      "invalid_type": "Se esperaba {{expected}}, se recibió {{received}}",
      "invalid_type_received_undefined": "Obligatorio",
      "invalid_literal": "Valor literal inválido, se esperaba {{expected}}",
      "unrecognized_keys": "Clave(s) no reconocida(s) en el objeto: {{keys}}",
      "invalid_union": "Entrada inválida",
      "invalid_union_discriminator": "Valor de discriminador inválido. Se esperaba {options}",
      "invalid_enum_value": "Valor de enumeración inválido. Se esperaba {{options}}, se recibió {{received}}",
      "invalid_arguments": "Argumentos de función inválidos",
      "invalid_return_type": "Tipo de retorno de función inválido",
      "invalid_date": "Fecha inválida",
      "custom": "Entrada inválida",
      "invalid_intersection_types": "Los resultados de la intersección no pudieron fusionarse",
      "not_multiple_of": "El número debe ser un múltiplo de {{multipleOf}}",
      "not_finite": "El número debe ser finito",
      "invalid_key": "Clave inválida en {{origin}}",
      "invalid_element": "Valor inválido en {{origin}}",
      "invalid_string": {
        "email": "{{validation}} inválido",
        "emoji": "{{validation}} inválido",
        "url": "{{validation}} inválido",
        "uuid": "{{validation}} inválido",
        "ulid": "{{validation}} inválido",
        "ip": "{{validation}} inválido",
        "cuid": "{{validation}} inválido",
        "cuid2": "{{validation}} inválido",
        "regex": "Inválido",
        "datetime": "{{validation}} inválido",
        "startsWith": "Entrada inválida: debe comenzar con {{startsWith}}",
        "endsWith": "Entrada inválida: debe terminar con {{endsWith}}"
      },
      "too_small": {
        "array": {
          "exact": "{{path}} debe contener exactamente {{minimum}} elemento(s)",
          "inclusive": "{{path}} debe contener al menos {{minimum}} elemento(s)",
          "not_inclusive": "{{path}} debe contener más de {{minimum}} elemento(s)"
        },
        "string": {
          "exact": "{{path}} debe contener exactamente {{minimum}} carácter(es)",
          "inclusive": "{{path}} debe contener al menos {{minimum}} carácter(es)",
          "not_inclusive": "{{path}} debe contener más de {{minimum}} carácter(es)"
        },
        "number": {
          "exact": "{{path}} debe ser exactamente {{minimum}}",
          "inclusive": "{{path}} debe ser mayor o igual a {{minimum}}",
          "not_inclusive": "{{path}} debe ser mayor que {{minimum}}"
        },
        "bigint": {
          "exact": "{{path}} debe ser exactamente {{minimum}}",
          "inclusive": "{{path}} debe ser mayor o igual a {{minimum}}",
          "not_inclusive": "{{path}} debe ser mayor que {{minimum}}"
        },
        "set": {
          "exact": "Entrada inválida",
          "inclusive": "Entrada inválida",
          "not_inclusive": "Entrada inválida"
        },
        "date": {
          "exact": "La fecha debe ser exactamente {{minimum, date}}",
          "inclusive": "La fecha debe ser mayor o igual a {{minimum, date}}",
          "not_inclusive": "La fecha debe ser mayor que {{minimum, date}}"
        }
      },
      "too_big": {
        "array": {
          "exact": "{{path}} debe contener exactamente {{maximum}} elemento(s)",
          "inclusive": "{{path}} debe contener como máximo {{maximum}} elemento(s)",
          "not_inclusive": "{{path}} debe contener menos de {{maximum}} elemento(s)"
        },
        "string": {
          "exact": "{{path}} debe contener exactamente {{maximum}} carácter(es)",
          "inclusive": "{{path}} debe contener como máximo {{maximum}} carácter(es)",
          "not_inclusive": "{{path}} debe contener menos de {{maximum}} carácter(es)"
        },
        "number": {
          "exact": "{{path}} debe ser exactamente {{maximum}}",
          "inclusive": "{{path}} debe ser menor o igual a {{maximum}}",
          "not_inclusive": "{{path}} debe ser menor que {{maximum}}"
        },
        "bigint": {
          "exact": "{{path}} debe ser exactamente {{maximum}}",
          "inclusive": "{{path}} debe ser menor o igual a {{maximum}}",
          "not_inclusive": "{{path}} debe ser menor que {{maximum}}"
        },
        "set": {
          "exact": "Entrada inválida",
          "inclusive": "Entrada inválida",
          "not_inclusive": "Entrada inválida"
        },
        "date": {
          "exact": "La fecha debe ser exactamente {{maximum, date}}",
          "inclusive": "La fecha debe ser menor o igual a {{maximum, date}}",
          "not_inclusive": "La fecha debe ser menor que {{maximum, date}}"
        }
      }
    },
    "validations": {
      "email": "correo electrónico",
      "emoji": "emoji",
      "url": "URL",
      "uuid": "UUID",
      "ulid": "ULID",
      "ip": "IP",
      "cuid": "CUID",
      "cuid2": "CUID2",
      "xid": "XID",
      "ksuid": "KSUID",
      "regex": "regex",
      "datetime": "fecha y hora",
      "date": "fecha",
      "time": "hora",
      "duration": "duración",
      "ipv4": "IPv4",
      "ipv6": "IPv6",
      "cidrv4": "rango IPv4",
      "cidrv6": "rango IPv6",
      "base64": "base64-encoded string",
      "base64url": "base64url-encoded string",
      "json_string": "JSON string",
      "e164": "E.164 number",
      "jwt": "JWT",
      "template_literal": "input",
      "uuidv4": "UUIDv4",
      "uuidv6": "UUIDv6",
      "nanoid": "nanoid",
      "guid": "GUID"
    },
    "types": {
      "function": "función",
      "number": "número",
      "string": "texto",
      "nan": "NaN",
      "integer": "entero",
      "float": "flotante",
      "boolean": "booleano",
      "date": "fecha",
      "bigint": "bigint",
      "undefined": "indefinido",
      "symbol": "símbolo",
      "null": "nulo",
      "array": "array",
      "object": "objeto",
      "unknown": "desconocido",
      "promise": "promesa",
      "void": "vacío",
      "never": "nunca",
      "map": "mapa",
      "set": "conjunto"
    },
    "custom": {},
    "paymentMethodRequired": "Por favor selecciona un método de pago"
  },
  "appleSignIn": {
    "userCancelled": "El inicio de sesión fue cancelado",
    "appleAuthFailed": "Autenticación con Apple falló. Por favor, inténtalo de nuevo.",
    "backendFailed": "No se pudo completar el sign-in. Por favor, inténtalo de nuevo.",
    "networkError": "Error de red. Por favor, verifica tu conexión y vuelve a intentarlo.",
    "unavailable": "Inicio de sesión con Apple no está disponible en este dispositivo",
    "invalidResponse": "Respuesta inválida de Apple. Por favor, inténtalo de nuevo.",
    "general": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo."
  },
  "googleSignIn": {
    "general": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo."
  },
  "appointment": {
    "tipUpdateFailed": "Error al actualizar la propina",
    "promoCodeUpdateFailed": "Error al aplicar código promocional",
    "promoCodeRemoveFailed": "Error al eliminar código promocional",
    "ratingUpdateFailed": "Error al enviar la calificación",
    "cancelFailed": "Error al cancelar el pedido",
    "unknownError": "Error desconocido"
  },
  "calendar": {
    "appleCalendarFailed": "Error al abrir Apple Calendar",
    "googleCalendarFailed": "Error al abrir Google Calendar",
    "yahooCalendarFailed": "Error al abrir Yahoo Calendar",
    "cannotOpenAppleCalendar": "No se puede abrir Apple Calendar",
    "cannotOpenGoogleCalendar": "No se puede abrir Google Calendar",
    "cannotOpenYahooCalendar": "No se puede abrir Yahoo Calendar",
    "appleCalendarNotAvailable": "Apple Calendar no está disponible en este navegador",
    "nativeCalendarNotAvailable": "El calendario nativo no está disponible en esta plataforma",
    "unknownError": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo."
  },
  "email": {
    "noEmailClient": "No hay cliente de correo disponible. Por favor, instala una aplicación de correo.",
    "failedToOpen": "Error al abrir el cliente de correo. Por favor, inténtalo de nuevo."
  },
  "cart": {
    "membershipPromoConflict": "Los códigos promocionales no se pueden combinar con tu descuento de membresía"
  }
}
